/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { Fallback } from './Fallback';
import { Header } from './Header';
import { Modals } from './Modals';
import { Navigation } from './Navigation';
import { Outlet } from 'react-router-dom';
import { PageContainer } from '@vaisala/rockhopper-components';
import { useNavigation } from '../state/navigation';

export const Layout = () => {
  const { collapsed, toggleNav, hierarchy, pageTitle, status } = useNavigation();

  return (
    <>
      <Navigation hierarchy={hierarchy} collapsed={collapsed} toggleNav={toggleNav} status={status} />
      <PageContainer>
        <Header title={pageTitle} logoVisible={collapsed} />
        <ErrorBoundary FallbackComponent={Fallback}>
          <Outlet />
        </ErrorBoundary>
      </PageContainer>
      <Modals />
    </>
  );
};

